import React from 'react';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';

const SiteMaintenance = props => {
  return (
    <Grid container direction="column" justify="center" alignItems="center" className="site-maintenance-container" wrap="nowrap">
      <Grid
        container
        direction="column"
        justify="flex-end"
        alignItems="center"
        xl={8}
        lg={8}
        sm={8}
        md={8}
        xs={8}
        className="site-maintenance-logo"
        wrap="nowrap">
        <Grid item xl={4} lg={4} sm={4} md={4} xs={4} className="logo-container">
          <img src="/images/EYlogo2.png" alt="EY Logo" />
          <div className="logo-text">{intl.get('maintenance.logoHeader')}</div>
        </Grid>
        <Grid item>
          <div className="logo-legend">{intl.get('maintenance.appName')}</div>
        </Grid>
      </Grid>
      <Grid
        xl={10}
        lg={10}
        sm={10}
        md={10}
        xs={10}
        container
        direction="column"
        justify="flex-start"
        alignItems="center"
        className="site-maintenance-msg">
        <Grid item direction="column" justify="center" alignItems="center" className="system-maintenance-msg">
          <div className="system-maintenance-title">{intl.get('maintenance.title')}</div>
          <div className="system-maintenance-text">{intl.get('maintenance.text')}</div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SiteMaintenance;



// WEBPACK FOOTER //
// ./src/ui/features/Maintenance/presentational/SiteMaintenancePres.js